import LangEnum from '../../../lang/LangEnum';
import { DocumentType } from '../types/customer.types';

export const DOCUMENT_TYPE_LABEL: Record<DocumentType, LangEnum> = {
  [DocumentType.CNPJ]: LangEnum.GLOBAL_CNPJ,
  [DocumentType.CPF]: LangEnum.GLOBAL_CPF,
  [DocumentType.TAX_ID]: LangEnum.CUSTOMER_DOC_TYPES_TAX_ID,
  [DocumentType.NIF]: LangEnum.CUSTOMER_DOC_TYPES_NIF,
  [DocumentType.PASSPORT]: LangEnum.CUSTOMER_DOC_TYPES_PASSPORT,
  [DocumentType.OTHERS]: LangEnum.CUSTOMER_DOC_TYPES_OTHERS,
};

const INTERNATIONAL_DOCUMENT_TYPES = [
  DocumentType.TAX_ID,
  DocumentType.NIF,
  DocumentType.PASSPORT,
  DocumentType.OTHERS,
];

export const internationalDocumentTypes = INTERNATIONAL_DOCUMENT_TYPES.map((value) => ({
  value,
  label: DOCUMENT_TYPE_LABEL[value],
}));
